import { HealthTeam } from "@/@types/esus/HealthTeam";
import { HealthUnit } from "@/@types/esus/HealthUnit";
import { Vaccination } from "@/@types/esus/Vaccination";
import { PaginationFilter } from "@/@types/generics/genericals";
import { Paginated } from "@/@types/generics/paginated";
import { esusApi } from "@/services/api";

export type DetailedCitizensVaccinationsIndicatorC3Params = PaginationFilter & {
	uf: string;
	ibgeCode: string;
	quarter: string;
	year: number;
	month: number;
	search: string;
	isEvaluated?: boolean;
	ine?: string;
	export?: boolean;
};

export class DetailedCitizenVaccinationsIndicatorC3Data {
	id: number = 0;
	cpf?: string;
	cns?: string;
	birthdate: string = "";
	fullName: string = "";
	healthUnitId: number = 0;
	healthTeamId: number = 0;
	healthUnit?: HealthUnit;
	healthTeam?: HealthTeam;
	area?: string;
	motherName?: string;
	gender?: number;
	street?: string;
	houseNumber?: string;
	neighborhood?: string;
	phone?: string;
	dumDate: string = "";
	dppDate: string = "";
	gestationalAge?: number;
	inactivePregnancyDate?: string;
	pregnancyStatus: "pregnant" | "puerperal" | "finished" = "pregnant";
	vaccines?: Vaccination[];
	vaccinationStatus: "finished" | "pending" | "lost" = "lost";
}

export async function getDetailedCitizensVaccinationsIndicatorC3({
	uf,
	ibgeCode,
	...params
}: DetailedCitizensVaccinationsIndicatorC3Params) {
	const response = await esusApi.get<Paginated<DetailedCitizenVaccinationsIndicatorC3Data>>(
		`/uf/${uf}/city/${ibgeCode}/indicator/esf/c3/detailed-citizens-vaccinations`,
		params
	);
	return response.data ?? new Paginated<DetailedCitizenVaccinationsIndicatorC3Data>();
}
